import { GET_SCHOOL_ROLES, GET_PERMISSIONS_AUDIT_HISTORIES } from '~/graphql/queries/academySettings'
import { ADD_USER_ROLE, CHANGE_USER_ROLE, REMOVE_USER_ROLE } from '~/graphql/mutations/setting'

const actionTypes = {
  GET_SCHOOL_ROLES: 'GET_SCHOOL_ROLES',
  ADD_USER_ROLE: 'ADD_USER_ROLE',
  CHANGE_USER_ROLE: 'CHANGE_USER_ROLE',
  REMOVE_USER_ROLE: 'REMOVE_USER_ROLE',
  GET_PERMISSIONS_AUDIT_HISTORIES: 'GET_PERMISSIONS_AUDIT_HISTORIES',
}

const mutationTypes = {
  SET_GETTING_ROLES: 'SET_GETTING_ROLES',
  SET_GETTING_PERMISSIONS_AUDIT: 'SET_GETTING_PERMISSIONS_AUDIT',
  SET_PERMISSIONS_AUDIT: 'SET_PERMISSIONS_AUDIT',
  SET_SCHOOL_ROLES: 'SET_SCHOOL_ROLES',
  SET_ADDING_USER_ROLE: 'SET_ADDING_USER_ROLE',
  SET_REMOVING_USER_ROLE: 'SET_REMOVING_USER_ROLE',
  SET_CHANGING_USER_ROLE: 'SET_CHANGING_USER_ROLE',
}

export const state = () => ({
  gettingRoles: false,
  gettingPermissionsAudit: false,
  addingUserRole: false,
  changingUserRole: false,
  removingUserRole: false,
  permissionsAudit: [],
  schoolRoles: [],
})

export const mutations = {
  [mutationTypes.SET_PERMISSIONS_AUDIT](state, permissionsAudit) {
    state.permissionsAudit = permissionsAudit
  },
  [mutationTypes.SET_GETTING_PERMISSIONS_AUDIT](state, gettingPermissionsAudit) {
    state.gettingPermissionsAudit = gettingPermissionsAudit
  },
  [mutationTypes.SET_SCHOOL_ROLES](state, schoolRoles) {
    state.schoolRoles = schoolRoles
  },
  [mutationTypes.SET_GETTING_ROLES](state, gettingRoles) {
    state.gettingRoles = gettingRoles
  },
  [mutationTypes.SET_ADDING_USER_ROLE](state, addingUserRole) {
    state.addingUserRole = addingUserRole
  },
  [mutationTypes.SET_REMOVING_USER_ROLE](state, removingUserRole) {
    state.removingUserRole = removingUserRole
  },
  [mutationTypes.SET_CHANGING_USER_ROLE](state, changingUserRole) {
    state.changingUserRole = changingUserRole
  },
}

export const actions = {
  async [actionTypes.GET_SCHOOL_ROLES]({ commit, rootState }) {
    commit(mutationTypes.SET_GETTING_ROLES, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.query({
        query: GET_SCHOOL_ROLES,
        fetchPolicy: 'no-cache',
        variables: { schoolId: rootState.school.schoolProfile.id },
      })
      commit(mutationTypes.SET_SCHOOL_ROLES, data.academyRoles)
      commit(mutationTypes.SET_GETTING_ROLES, false)
      return { data, success: true }
    } catch (error) {
      commit(mutationTypes.SET_GETTING_ROLES, false)
      console.error('GET_SCHOOL_ROLES', error)
      return { error, success: false }
    }
  },
  async [actionTypes.GET_PERMISSIONS_AUDIT_HISTORIES]({ commit, rootState }) {
    commit(mutationTypes.SET_GETTING_PERMISSIONS_AUDIT, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.query({
        query: GET_PERMISSIONS_AUDIT_HISTORIES,
        fetchPolicy: 'no-cache',
        variables: { schoolId: rootState.school.schoolProfile.id },
      })
      commit(mutationTypes.SET_PERMISSIONS_AUDIT, data.academyPermissionAuditHistories)
      commit(mutationTypes.SET_GETTING_PERMISSIONS_AUDIT, false)
      return { data, success: true }
    } catch (error) {
      commit(mutationTypes.SET_GETTING_PERMISSIONS_AUDIT, false)
      console.error('GET_PERMISSIONS_AUDIT_HISTORIES', error)
      return { error, success: false }
    }
  },
  async [actionTypes.ADD_USER_ROLE]({ commit, rootState }, params) {
    commit(mutationTypes.SET_ADDING_USER_ROLE, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const response = await apolloClient.mutate({
        mutation: ADD_USER_ROLE,
        variables: { ...params, schoolId: rootState.school.schoolProfile.id },
      })
      commit(mutationTypes.SET_ADDING_USER_ROLE, false)
      return { response, success: true }
    } catch (error) {
      commit(mutationTypes.SET_ADDING_USER_ROLE, false)
      console.error('ADD_USER_ROLE', error)
      return { error, success: false }
    }
  },
  async [actionTypes.REMOVE_USER_ROLE]({ commit, rootState }, params) {
    commit(mutationTypes.SET_REMOVING_USER_ROLE, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const response = await apolloClient.mutate({
        mutation: REMOVE_USER_ROLE,
        variables: { ...params, schoolId: rootState.school.schoolProfile.id },
      })
      commit(mutationTypes.SET_REMOVING_USER_ROLE, false)
      return { response, success: true }
    } catch (error) {
      commit(mutationTypes.SET_REMOVING_USER_ROLE, false)
      console.error('REMOVE_USER_ROLE', error)
      return { error, success: false }
    }
  },
  async [actionTypes.CHANGE_USER_ROLE]({ commit, rootState }, params) {
    commit(mutationTypes.SET_CHANGING_USER_ROLE, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const response = await apolloClient.mutate({
        mutation: CHANGE_USER_ROLE,
        variables: { ...params, schoolId: rootState.school.schoolProfile.id },
      })
      commit(mutationTypes.SET_CHANGING_USER_ROLE, false)
      return { response, success: true }
    } catch (error) {
      commit(mutationTypes.SET_CHANGING_USER_ROLE, false)
      console.error('CHANGE_USER_ROLE', error)
      return { error, success: false }
    }
  },
}

export const getters = {
  schoolRoles: (state) => state.schoolRoles,
  addingUserRole: (state) => state.addingUserRole,
  removingUserRole: (state) => state.removingUserRole,
  changingUserRole: (state) => state.changingUserRole,
  gettingRoles: (state) => state.gettingRoles,
  permissionsAudit: (state) => state.permissionsAudit,
  gettingPermissionsAudit: (state) => state.gettingPermissionsAudit,
}
